module.exports = __webpack_public_path__ + "img/99speedmart-img.31c0f34f.png";